<template>
  <div class="product">
    <banner img="../assets/img/bgtop.jpg" title="产品中心" />
    <!--产品一:空中课堂平台端-->
    <div class="product-content" v-loading="loading">
      <div class="p-video">
        <p style="text-align: center;color:black;font-size:33px;font-weight: bold;position: relative;right: 17px">
            <img style="width: 70px;height: 45px;position: relative;top: 12px;right: 5px" src="https://www.eastsun.net/eastsunImg/kongzhonglogo.png" alt="">
            <span>空&nbsp;中&nbsp;课&nbsp;堂</span>
        </p>
        <br/>
        <p>
          <span style="font-weight: bold">"空中课堂"平台——web端。</span><br/>
          <span style="font-weight: bold">为满足校方实现无线远程现场施工教学监控设备及校方各系各专业视频精品课件配套，还有教师自己的精品课件能够通过一个完整的平台软件去展示教学。</span>
          <span style="font-weight: bold;">东太公司提供了一整套解决方案，从监控设备的安装、调试、录像存储、接入监控平台到精品课件的课堂教学，以及保证数据的安全、稳定的云服务,保证课件实时在线播放的平台，我们称之为“空中课堂平台”。</span>
          <span style="font-weight: bold;">平台可实现校内、校外网络访问，方便学生、教师访问。</span>
        </p>
       <br/>
        <img style="width: 100%;height: 500px" src="https://www.eastsun.net/eastsunImg/kongzhongimg.png" alt="">
      </div>
      <!--产品二:空中课堂APP-->
      <div class="product-content" v-loading="loading">
        <div class="p-video">
          <p style="text-align: center;color:black;font-size:33px;font-weight: bold;position: relative;right: 17px">
            <img style="width: 70px;height: 45px;position: relative;top: 12px;right: 5px" src="https://www.eastsun.net/eastsunImg/kongzhonglogo.png" alt="">
            <span>空&nbsp;中&nbsp;课&nbsp;堂&nbsp;App</span>
          </p>
          <br/>
          <p>
            <span style="font-weight: bold">手机端"空中课堂"——App。</span><br/>
            <span style="font-weight: bold">根据平台又开发了一款手机端APP,方便老师与学生们在手机上也可以很好的上课学习交流。</span><br/>
            <span style="font-weight: bold;">"视频管理系列"中有: 实时浏览是用户实时观看现场摄像头拍摄的现场视频，真实的场景，加强用户对施工现场的了解，提高学习兴趣，方便教学；录像回放为用户查看摄像头拍摄的录像情况，帮助用户查看没看到现场情况，做到有据可查；切片查询是用户查看视频剪辑出来的按顺序播放的摄像头拍摄的图片；视频播放为播放本地视频文件，用户可以选择自己本地保存的视频在平台上进行播放。</span><br/>
            <span style="font-weight: bold;">"违规管理系列"中有: 违规抓拍为学生通过视频监控抓拍工地上施工的违规行为，并提交给老师批阅，批阅违规为老师对学生上传的违规抓拍进行批阅，整改抓拍为老师批阅违规后，发给学生需要整改的，违规行为整改后，学生将整改后的内容拍照，再次交由老师进行审核批阅，批阅整改为老师审核批阅学生提交的违规整改之后的内容等。</span><br/>
          </p>
          <br/>
          <img style="width: 50%;height: 750px;line-height: 750px;margin: 0 25%" src="https://www.eastsun.net/eastsunImg/kongzhongApptwo.png" alt="">
        </div>
      </div>
      <!--产品三:治理监测平台-->
      <div class="product-content" v-loading="loading">
        <div class="p-video">
          <p style="text-align: center;color:black;font-size:33px;font-weight: bold;position: relative;right: 17px">
            <img style="width: 70px;height: 45px;position: relative;top: 12px;right: 5px" src="https://www.eastsun.net/eastsunImg/waterlogo.png" alt="">
            <span>治&nbsp;理&nbsp;监&nbsp;测</span>
          </p>
          <br/>
          <p>
            <span style="font-weight: bold">"治理监测平台"——web端。</span><br/>
            <span style="font-weight: bold">通过扫描“河道二维码”，我们可以输入投诉内容，可以上传照片以及小视频，进行群策群讼。</span>
            <span style="font-weight: bold;">监控测点模块,绑定监控设备和河道,展示指定河道上的监控信息,提供云台功能，可180度旋转摄像头。</span><br/>
            <span style="font-weight: bold;">河道资料模块提供了水质标准文档和河道名称代码文档以供查看。</span><br/>
            <span style="font-weight: bold;">巡河记录模块,巡检员进入此模块进行每日巡河记录填写上报到平台，管理人员会对每日的异常巡河记录进行处理,也可上报到河长进行处理,形成问题的闭环处理。</span><br/>
            <span style="font-weight: bold;">签到打卡模块,巡检员进入此模块进行巡检测点的每日签到打卡,数据会上报到平台端供管理人员查看等功能。</span>
          </p>
          <br/>
          <img style="width: 100%;height: 500px" src="https://www.eastsun.net/eastsunImg/daping.png" alt="">
        </div>
      </div>
      <!--产品四:治理检测APP-->
      <div class="product-content" v-loading="loading">
        <div class="p-video">
          <p style="text-align: center;color:black;font-size:33px;font-weight: bold;position: relative;right: 17px">
            <img style="width: 70px;height: 45px;position: relative;top: 12px;right: 5px" src="https://www.eastsun.net/eastsunImg/waterlogo.png" alt="">
            <span>治&nbsp;理&nbsp;监&nbsp;测&nbsp;App</span>
          </p>
          <br/>
          <p>
            <span style="font-weight: bold">手机端"治理监测"——App。</span><br/>
            <span style="font-weight: bold">地图导航模块,在地图上展示所有的测点,可进行相应的搜索,用户可实时查看所有测点的位置信息。</span>
            <span style="font-weight: bold;">人员管理模块,可添加管理员,河长,巡查员,处理员等角色用户，不同角色有不同的权限及分工,例巡查员负责每日巡查河道，上传巡河日志,处理员负责处理异常的巡河日志,河长负责管理指定河道,管理元可查看区域的所有河道。</span><br/>
            <span style="font-weight: bold;">设备设置模块,可添加水质，监控,治理等不同设备,用于后续和河道一起绑定到测点上，进行监测。</span><br/>
            <span style="font-weight: bold;">水质测点模块, 绑定水质设备和河道,对河道进行水质监测,上传水质数据，使用蜘蛛网图展示当天数据,使用折线图展示历史数据。</span><br/>
            <span style="font-weight: bold;">智慧物联模块,提供了对治理设备的边缘网关进行操控,提供历史列表查看所有下发的指令等功能;</span>
          </p>
          <br/>
          <img style="width: 50%;height: 800px;line-height: 800px;margin: 0 25%" src="https://www.eastsun.net/eastsunImg/waterApp.png" alt="">
        </div>
      </div>
      <!--产品五:发展中心平台-->
      <div class="product-content" v-loading="loading">
        <div class="p-video">
          <p style="text-align: center;color:black;font-size:33px;font-weight: bold;position: relative;right: 17px">
            <img style="width: 50px;height: 38px;position: relative;top: 8px;right: 5px" src="https://www.eastsun.net/eastsunImg/fazhanlogo.png" alt="">&nbsp;
            <span>发&nbsp;展&nbsp;中&nbsp;心&nbsp;平&nbsp;台</span>
          </p>
          <br/>
          <p>
            <span style="font-weight: bold">"发展中心平台"。</span><br/>
            <span style="font-weight: bold">方案中心平台软件是我公司自主开发的多功能建设工程监管平台。</span>
            <span style="font-weight: bold;">平台具有登录、首页、项目详情、前期阶段、项目进度、招投标管理、合同管理、现场管理、工程月报等多项功能模块。</span><br/>
            <span style="font-weight: bold;">在工地上可以高效的调用多个场地的视频，不受时空的限制，可以多角度的看到实时的建设状况。</span><br/>
          </p>
          <br/>
          <img style="width: 100%;height: 500px" src="https://www.eastsun.net/eastsunImg/fazhan.png" alt="">
        </div>
      </div>
      <!--产品六:农业大屏-->
      <div class="product-content" v-loading="loading">
        <div class="p-video">
          <p style="text-align: center;color:black;font-size:33px;font-weight: bold;position: relative;right: 17px">
            <img style="width: 80px;height: 50px;position: relative;top: 15px;left:15px" src="https://www.eastsun.net/eastsunImg/dongtailogo.png" alt="">&nbsp;
            <span>农&nbsp;业&nbsp;智&nbsp;慧&nbsp;物&nbsp;联&nbsp;促&nbsp;生&nbsp;长&nbsp;管&nbsp;控&nbsp;平&nbsp;台</span>
          </p>
          <br/>
          <p>
            <span style="font-weight: bold">"农业智慧物联促生长管控平台"。</span><br/>
            <span style="font-weight: bold">农业智慧物联促生长管控平台，是一种基于物联网技术的农业管理系统。</span>
            <span style="font-weight: bold;">旨在提高农业生产的效率和可持续性。该系统通过实时监测农作物生长环境、畜禽和水产养殖等，实现精准感知、及时反馈和农业决策智慧化。</span><br/>
            <span style="font-weight: bold;">体来说，农业智慧物联促生长管控平台可以促进农业可持续发展，提高农业种植的单产和总产量，增加农民的经济收入。</span><br/>
            <span style="font-weight: bold;">同时,该系统还可以为不同的农作物创造更加适宜的生长环境，满足不同作物的水、气、肥、光照、湿度、温度等需求，进而增加农业收入。</span>
          </p>
          <br/>
          <img style="width: 100%;height: 500px" src="https://www.eastsun.net/eastsunImg/nongye.png" alt="">
        </div>
      </div>
      <!--产品七:弱电智能化工程-->
      <div class="product-content" v-loading="loading">
        <div class="p-video">
          <p style="text-align: center;color:black;font-size:33px;font-weight: bold;position: relative;right: 17px">
            <img style="width: 80px;height: 50px;position: relative;top: 15px;left:15px" src="https://www.eastsun.net/eastsunImg/dongtailogo.png" alt="">&nbsp;
            <span>弱&nbsp;电&nbsp;智&nbsp;能&nbsp;化&nbsp;工&nbsp;程</span>
          </p>
          <br/>
          <p>
            <span style="font-weight: bold">"弱电智能化工程"。</span><br/>
            <span style="font-weight: bold">开发建设的弱电智能化设备工程内容主要是弱电系统的管线预埋、弱电设备的安装和调试，共包括视频监控系统、电子巡更系统、多媒体信息发布系统、校园智能广播系统、有线电视系统、计算机网络系统、入侵报警系统、出入口控制系统、食堂消费管理系统、多媒体教学系统、综合布线系统等11个分项工程。。</span>
            <span style="font-weight: bold;">弱电智能化是以电能、电气设备和电气技术为手段来创造、维持与改善限定空间和环境的一门技术。。</span><br/>
            <span style="font-weight: bold;">通过四个基本要素即结构、系统、服务、管理的最优考虑来提供一个投资合理的但又拥有高效率的舒适、温馨、便利的环境。
本智能化系统工程所采用的材料和设备均符合设计图纸要求与行业标准并附有出厂合格证。管线施工、设备安装严格按照相关的施工与安装规范进行施工，设备安装位置符合设计图纸要求。。</span><br/>
            <span style="font-weight: bold;">该工程自  2022年 1月开始进场施工，在领导和专家悉心指导和帮助下，于2023年5 月底已完成了弱电设备的安装和调试工作，经过试运行，系统工作稳定，本工程经我公司自检自查，施工质量完全符合规范及设计要求，目前已完成竣工验收。。</span>
          </p>
          <br/>
          <img style="width: 100%;height: 500px" src="https://www.eastsun.net/eastsunImg/ruodian.jpg" alt="">
        </div>
      </div>
      <!--产品八:2."指挥中心"-->
      <div class="product-content" v-loading="loading">
        <div class="p-video">
          <p style="text-align: center;color:black;font-size:33px;font-weight: bold;position: relative;right: 17px">
            <img style="width: 80px;height: 50px;position: relative;top: 15px;left:15px" src="https://www.eastsun.net/eastsunImg/dongtailogo.png" alt="">&nbsp;
            <span>指&nbsp;辉&nbsp;中&nbsp;心</span>
          </p>
          <br/>
          <p>
            <span style="font-weight: bold">"指挥中心"。</span><br/>
            <span style="font-weight: bold">指挥中心是由一系列的音、视频系统，以及对它们进行控制的集中控制系统和场所保障环境组成的安全的、智能化的指挥环境，包括显示系统、音响与会议系统、集中控制系统、灯光照明系统、综合布线系统、供配电系统、场所安全防护系统等。</span>
            <span style="font-weight: bold;">指挥中心功能主要有日常会议、远程视频会议、执行现场指挥、内网大数据分析、联合相关部门信息决策，预览视频监控，综合调度指挥等。</span><br/>
            <span style="font-weight: bold;">指挥中心总体设计上采用网络化、智能化、集中控制和分散控制相结合的整体设计思想，通过综合布线系统互联指挥大厅、控制室、会商室、指挥长室、安监值班室、环保值班室、园区值班室、机房等功能区域的多种设备，对场所内各种音视频信号进行集中交换与处理。</span><br/>
            <span style="font-weight: bold;">并对各种显示设备、音响与会议设备等进行集中控制，满足指挥中心的需求，如值班、进行会议。</span>
          </p>
          <br/>
          <img style="width: 100%;height: 500px" src="https://www.eastsun.net/eastsunImg/zhihuizhongxin.png" alt="">
        </div>
      </div>
      <!--产品九:3."会议系统"-->
      <div class="product-content" v-loading="loading">
        <div class="p-video">
          <p style="text-align: center;color:black;font-size:33px;font-weight: bold;position: relative;right: 17px">
            <img style="width: 80px;height: 50px;position: relative;top: 15px;left:15px" src="https://www.eastsun.net/eastsunImg/dongtailogo.png" alt="">&nbsp;
            <span>会&nbsp;议&nbsp;系&nbsp;统</span>
          </p>
          <br/>
          <p>
            <span style="font-weight: bold">"会议系统"。</span><br/>
            <span style="font-weight: bold">会议系统主要由麦克风、功放、音响、显示设备、视频设备等构成，部分会议室还有中控系统以及LED拼接屏，满足视频会议，远程电话会议等需求，使用多台数字会议主机及控制软件，可以对整个会场进行全面的控制，使会议更加高效的举行，该软件操作简单，功能强大。</span>
            <span style="font-weight: bold;">适用于各大、中、小型会议室，会议厅等。无纸化会议系统具有节能环保、提高效率、实用性强、操作便捷，统一管理、保密性强、安全稳定、成本较低、全平台兼容等优势。</span><br/>
            <span style="font-weight: bold;">该项目落成，极大的简化了以往会议繁琐的操作程序，大大提高了会议效率，方便交流、培训、管理及维护，节约长期投资成本，对整体效率的提高起了至关重要的作用
。</span><br/>
          </p>
          <br/>
          <img style="width: 100%;height: 500px" src="https://www.eastsun.net/eastsunImg/huiyi.jpg" alt="">
        </div>
      </div>
      <!--产品十:4."无纸化办公"系统-->
      <div class="product-content" v-loading="loading">
        <div class="p-video">
          <p style="text-align: center;color:black;font-size:33px;font-weight: bold;position: relative;right: 17px">
            <img style="width: 80px;height: 50px;position: relative;top: 15px;left:15px" src="https://www.eastsun.net/eastsunImg/dongtailogo.png" alt="">&nbsp;
            <span>无&nbsp;纸&nbsp;化&nbsp;办&nbsp;公</span>
          </p>
          <br/>
          <p>
            <span style="font-weight: bold">"无纸化办公"。</span><br/>
            <span style="font-weight: bold">无纸化办公系统是指在不用纸张办公，在无纸化办公环境中进行的一种工作系统，无纸化办公需要硬件、软件与通信网络协力才能达到的办公体验。</span>
            <span style="font-weight: bold;">本项目抓住传统行政办公方式工作效率较低，适用范围窄的问题，依靠大数据管理调配，基于JAVA与B/S架构，设计制作一体化无纸办公系统，简化审批流程，加强环境保护，进而实现构建稳定高效安全的政务系统，加快办公、惠民、基建等信息在居民和各部门之间的信息交流和沟通，推动数字型政府建设。</span><br/>
            <span style="font-weight: bold;">无纸化办公不仅是一种环保的做法，更是提升企业竞争力的关键一步。通过设定明确目标、投资适合的技术工具、推动文化变革等方法，企业可以实现高效的无纸化办公，走向更加美好的工作未来。</span><br/>
          </p>
          <br/>
          <img style="width: 100%;height: 500px" src="https://www.eastsun.net/eastsunImg/wuzhihua.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>






<!--      <div class="lacking">-->
<!--        <h3 class="title">传统管理模式不足</h3>-->
<!--        <div class="lacking-bottom">-->
<!--          <div class="lacking-bottom-item">-->
<!--            <div class="lacking-bottom-item-img">-->
<!--              <img src="../assets/img/product-group-icon_3.png" alt />-->
<!--            </div>-->
<!--            <p>质量检查、安全检查以抽查为主，难免存在遗漏，留下质量安全隐患。</p>-->
<!--          </div>-->

<!--          <div class="lacking-bottom-item">-->
<!--            <div class="lacking-bottom-item-img">-->
<!--              <img src="../assets/img/product-group-icon_2.png" alt />-->
<!--            </div>-->
<!--            <p>数据统计、数据分析的缺失，无法为统计、分析、项目评估等工作提供数据支撑。</p>-->
<!--          </div>-->

<!--          <div class="lacking-bottom-item">-->
<!--            <div class="lacking-bottom-item-img">-->
<!--              <img src="../assets/img/product-group-icon_1.png" alt />-->
<!--            </div>-->
<!--            <p>检查工作和检查记录文件脱节，无法做到同步对应；缺少影像文档，无法做到可追溯性。</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash; 平台目标 &ndash;&gt;-->
<!--      <div class="target">-->
<!--        <h3 class="title">平台目标</h3>-->
<!--        <p class="eTitle">TARGET</p>-->
<!--        <div class="target-img">-->
<!--          <img src="../assets/img/product_group_3_img.png" alt />-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash;功能模块  &ndash;&gt;-->
<!--      <div class="modular">-->
<!--        <h3 class="title">功能模块</h3>-->
<!--        <p class="eTitle">MODULAR</p>-->
<!--        <div class="modular-content">-->
<!--          <div class="modular-content-same">-->
<!--            <div class="same-item">-->
<!--              <div class="same-item-img">-->
<!--                <img src="../assets/img/product-group_4-icon_1.png" alt />-->
<!--              </div>-->
<!--              <p>质量控制模块</p>-->
<!--            </div>-->
<!--            <div class="same-item">-->
<!--              <div class="same-item-img">-->
<!--                <img src="../assets/img/product-group_4-icon_2.png" alt />-->
<!--              </div>-->
<!--              <p>知识仓库模块</p>-->
<!--            </div>-->
<!--            <div class="same-item">-->
<!--              <div class="same-item-img">-->
<!--                <img src="../assets/img/product-group_4-icon_3.png" alt />-->
<!--              </div>-->
<!--              <p>信息流程模块</p>-->
<!--            </div>-->
<!--            <div class="same-item">-->
<!--              <div class="same-item-img">-->
<!--                <img src="../assets/img/product-group_4-icon_1.png" alt />-->
<!--              </div>-->
<!--              <p>定位复核模块</p>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="modular-content-center">-->
<!--            <img src="../assets/img/product_group_4_img.png" alt />-->
<!--          </div>-->
<!--          <div class="modular-content-same">-->
<!--            <div class="same-item">-->
<!--              <p>信息处理模块</p>-->
<!--              <div class="same-item-img">-->
<!--                <img src="../assets/img/product-group_4-icon_5.png" alt />-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="same-item">-->
<!--              <p>材料设备模块</p>-->
<!--              <div class="same-item-img">-->
<!--                <img src="../assets/img/product-group_4-icon_6.png" alt />-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="same-item">-->
<!--              <p>进度控制模块</p>-->
<!--              <div class="same-item-img">-->
<!--                <img src="../assets/img/product-group_4-icon_7.png" alt />-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="same-item">-->
<!--              <p>安全管理模块</p>-->
<!--              <div class="same-item-img">-->
<!--                <img src="../assets/img/product-group_4-icon_8.png" alt />-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->

<script>
import Banner from "../components/Banner";
export default {
  data() {
    return {
      loading: true,
      videoSrc: "http://www.shkjem.com/video/kj.mp4",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "https://aa419870683.oss-cn-beijing.aliyuncs.com/754306557-1-16.mp4" //url地址
          }
        ],
        //poster: "../assets/img/home_top.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  },
  components: {
    Banner
  },
  created() {
    this.videoSrc='https://cn-jsnt-ct-01-03.bilivideo.com/upgcxcode/57/65/754306557/754306557-1-16.mp4?e=ig8euxZM2rNcNbRVhwdVhwdlhWdVhwdVhoNvNC8BqJIzNbfq9rVEuxTEnE8L5F6VnEsSTx0vkX8fqJeYTj_lta53NCM=&uipk=5&nbs=1&deadline=1701087235&gen=playurlv2&os=bcache&oi=605292301&trid=00009fa0033a8ccc44c490cd44dd3ab66c4fT&mid=429592341&platform=html5&upsig=494a66e5aac1d8ca96f07f65921c5a0a&uparams=e,uipk,nbs,deadline,gen,os,oi,trid,mid,platform&cdnid=4275&bvc=vod&nettype=0&bw=53366&orderid=0,1&buvid=&build=0&mobi_app=&f=T_0_0&logo=80000000'
    this.loading = false;
    // this.$http
    //   .get(
    //     "DataDictionary/GetDataDictionaryAll?key=%E4%BA%A7%E5%93%81%E8%A7%86%E9%A2%91%E9%93%BE%E6%8E%A5"
    //   )
    //   .then(response => {
    //     this.videoSrc = response.data[0].Content;
    //     window.console.log(this.videoSrc);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  }
};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  height: 100%;
  background-color: #14679f;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}

.p-video {
  width: 1000px;
  margin: 0 auto;
  padding: 60px 0;
}

//传统管理模式不足
.lacking {
  height: 420px;
  padding: 20px 0;
  //margin: 20px 0;

  .lacking-bottom {
    display: flex;
    justify-content: space-around;
    padding: 100px 100px;

    .lacking-bottom-item {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      //justify-content: center;

      .lacking-bottom-item-img {
        width: 120px;
        height: 120px;
        background: #1667a0;
        border-radius: 50%;
        overflow: hidden;
        line-height: 160px;
      }
    }
    p {
      font-size: 16px;
      text-align: start;
      margin: 10px 0;
    }
  }
}

//平台目标
.target {
  margin-top: 50px;
  &-img {
    margin-top: 50px;
    text-align: center;
  }
}

//
.modular {
  margin-top: 50px;
  .modular-content {
    padding: 50px 50px;
    display: flex;
    justify-content: space-around;
  }
}
.modular-content-same {
  width: 182px;
  height: 405px;

  .same-item {
    height: 70px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;

    .same-item-img {
      width: 70px;
      height: 70px;
      line-height: 100px;
      background: #1667a0;
      border-radius: 50%;
      text-align: center;
    }
    p {
      color: #1667a0;
      font-weight: 700;
      line-height: 70px;
    }
  }
}

.modular-content-center {
  width: 355px;
  height: 355px;
  img {
    width: 100%;
  }
}
//公共样式
.title,
.eTitle {
  font-size: 34px;
  font-weight: 400;
  color: #333;
  text-align: center;
}
.eTitle {
  font-size: 30px;
  padding: 10px 0;
}
</style>
